import React from 'react';

// GLOBAL COMPONENTS
import Sidebar from 'parts/sidebar/Sidebar';

// LOCAL COMPONENTS
import PricingInfo from './WholeSaleTrade/PricingInfo';
import InventoryInternal from './WholeSaleTrade/InventoryInternal';
import PurchaseInfo from './WholeSaleTrade/PurchaseInfo';
import VehicleInfo from './WholeSaleTrade/VehicleInfo';
import InventoryAttachments from './WholeSaleTrade/InventoryAttachments';

// STYLES
import styles from '../trade.module.scss';

// MAIN COMPONENT
const WholeSaleTrade = ({
  initialValues,
  handleCancel,
  handleSubmit,
  index
}) => (
  <Sidebar.Form
    initialValues={initialValues}
    body={{ vertical: true, className: styles.body }}
    onSubmit={handleSubmit}
    buttons={{
      submit: {
        variant: 'success',
        label: 'Review In Deal'
      },
      cancel: {
        onClick: handleCancel
      }
    }}
  >
    <VehicleInfo index={index} />
    <PricingInfo index={index} />
    <InventoryInternal index={index} />
    <PurchaseInfo index={index} />
    <InventoryAttachments index={index} />
  </Sidebar.Form>
);

export default WholeSaleTrade;
